import { Action } from "redux";
import { LinkData } from "../types/index.js";
import { isActionType } from "./utils.js";

const ActionTypeKeys = ["SET_LINK_SELECT", "RESET_LINK_SELECT"] as const;

type ActionType = (typeof ActionTypeKeys)[number];
type ActionBase<T extends ActionType> = Action<T>;

type SetLinkSelect = ActionBase<"SET_LINK_SELECT"> & {
  id: string;
  linkData: LinkData;
  confirm: boolean;
};
type ResetLinkSelect = ActionBase<"RESET_LINK_SELECT">;

export type LinkSelectAction = SetLinkSelect | ResetLinkSelect;

export const isLinkSelectAction = (
  action: Action,
): action is LinkSelectAction => isActionType(action, ActionTypeKeys);

export const setLinkSelect = (
  id: string,
  linkData: LinkData,
  confirm: boolean,
): SetLinkSelect => ({ type: "SET_LINK_SELECT", id, linkData, confirm });

export const resetLinkSelect = (): ResetLinkSelect => ({
  type: "RESET_LINK_SELECT",
});
